module.exports = __webpack_public_path__ + "static/media/icon_payments_trans.7ba326c2.svg";